// @ts-nocheck
import { SocialNetwork } from '../ShareButton';

const translation = {
  SHARE_LABEL: ({ socialNetwork }: { socialNetwork: SocialNetwork }) =>
    `Compartilhar no ${socialNetwork}`,
};

export default translation;
